
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'test-lineup',
    templateUrl: 'test-lineup.html',
    encapsulation: ViewEncapsulation.None
})
export class LineTestPage {
   context: any;
   routerState:any;

   constructor(
    private router:Router,
    public sanitizer: DomSanitizer
    ){
    const nav = this.router.getCurrentNavigation();
    this.routerState = nav?.extras?.state || {};
    this.context = this.routerState.get('context');
   }
}

